import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export type IGenericDeleteDialogProps = {
    openDialog: boolean
    title: string
    message: string
    handleClose: () => void
    handleDelete: () => void
};

export default function GenericDeleteDialog({ openDialog, title, message, handleClose, handleDelete }: IGenericDeleteDialogProps) {
    const { t } = useTranslation();
    
    return (
        <Dialog
            open={openDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="outlined" color="secondary">{t('no', 'No')}</Button>
                <Button onClick={handleDelete} autoFocus variant="contained" color="error">{t('yes', 'Yes')}</Button>
            </DialogActions>
        </Dialog>
    )
}